import React from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { Upload } from 'antd';
import { Modal } from 'react-bootstrap';
import { InboxOutlined } from '@ant-design/icons';
import { URL_API_UPLOAD, REQUEST_URL, FTP_URL } from '../config/urls';

export default class CadastrarPublicacao extends React.Component {
  state = {
    fileList: [],
    uploading: false,
    contrato: 0,
    publicacoes: {},
    indexImageView:{
      'Paginação': 0,
      'Capa Dura': 0,
      'Embalagem': 0,
      'Encarte': 0,
      'Convite Simples': 0,
      'Senha de Entrada': 0,
      'Missal': 0,
      'Outros Produtos': 0,
      'Personalizadas': 0
    },
    contratoConfirmado: false,
    carregando: false,
    carregandoImagens: false,
    countFiles: 0,
    percentItems: [],
    keyPublicacoes: [],
    respostasUpload: [],
    showModalCodigos: false,
    showModalUpload: false,
  }

  componentDidMount () {
    document.querySelector("#inputContrato").select();
  }

  abrirModalUpload = async () => {
    this.setState({uploading: true});
    
    let { publicacoes } = this.state,
      keyPublicacoes = [],
      percentItems = [];
    
    for (var key in publicacoes) {
      if (this.contemPaginaNova(publicacoes, key)) {
        keyPublicacoes.push(key);
        percentItems.push(0);
      }
    }

    await this.setState({ keyPublicacoes, showModalUpload: true, percentItems }, async () => {
      this.handleUpload();
    });
  }

  handleUpload = async () => {
    let { publicacoes, keyPublicacoes, respostasUpload, percentItems } = this.state,
      teveErro = false;

    for (let i = 0; i < keyPublicacoes.length; i++) {
      let key = keyPublicacoes[i], 
        formData = new FormData(),
        options = null;
      
      options = {
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          percentItems[i] = Math.floor((loaded * 100) / total);
          this.setState({ percentItems });
        }
      };
      
      publicacoes[key].nova.forEach(file => {
        if (file instanceof File) { 
          formData.append('imagens[]', file);
        }
      });
      
      formData.append('contrato', this.state.contrato);
      formData.append('tipo', key);

      await axios.post(URL_API_UPLOAD, formData, options).then((response) => {
        respostasUpload.push(true);
        this.setState({ respostasUpload });
      }).catch((erro) => {
        teveErro = true;
        respostasUpload.push(false);
        this.setState({ respostasUpload });
      });
    }

    if (!teveErro) {
      this.resetar();
      toast.success("Publicações cadastradas com sucesso!");
    } else {
      this.setState({uploading: false});
    }

  }

  contemPaginaNova (publicacoes, key) {
    return publicacoes[key].nova.filter((p) => { return p.nome !== "Aguardando" && p.url !== null }).length > 0;
  }

  async beforeUpload(file) {
    let reader = new FileReader();

    await reader.readAsDataURL(file);
    await this.pegarTipo(file);

    reader.onloadstart = async () => {
      let { countFiles } = this.state;
      countFiles++;
      this.setState({ countFiles, carregandoImagens: true });
    };

    reader.onloadend = async () => {
      file.url = reader.result;
      file.thumbUrl = reader.result;
      await this.setState(({ fileList , imgsSlots }) => ({fileList: [...fileList, file]}));
      if (this.state.countFiles === this.state.fileList.length) {
        this.setState({carregandoImagens: false});
      }
    };

    return false;
  }

  pegarTipo(file){
    const arquivo = file.name;
    let tipos = {
      conviteLuxo: {
        tipo: "Paginação",
        regex: "^l$"
      },
      paginaPersonalizada: {
        tipo: "Paginação",
        regex: "^j$"
      },
      capaDoBloco: {
        tipo: "Paginação",
        regex: "^b$"
      },
      vegetal: {
        tipo: "Paginação",
        regex: "^v$"
      },
      displayFlexPersonalizado: {
        tipo: "Paginação",
        regex: "^f$"
      },
      pdfCapaDura: {
        tipo: "Capa Dura",
        regex: "^pdf$"
      },
      capaDura: {
        tipo: "Capa Dura",
        regex: "^d$"
      },
      caixa: {
        tipo: "Embalagem",
        regex: "^x$"
      },
      envelope: {
        tipo: "Embalagem",
        regex: "^ep$"
      },
      involucro: {
        tipo: "Embalagem",
        regex: "^i$"
      },
      encarte: {
        tipo: "Encarte",
        regex: "^e$"
      },
      conviteSimples: {
        tipo: "Convite Simples",
        regex: "^s$"
      },
      senhaDeEntrada: {
        tipo: "Senha de Entrada",
        regex: "^h$"
      },
      missal: {
        tipo: "Missal",
        regex: "^ms$"
      },
      codex: {
        tipo: "Outros Produtos",
        regex: "^o$"
      },
      capaDoCodex: {
        tipo: "Outros Produtos",
        regex: "^cc$"
      },
      standUp: {
        tipo: "Outros Produtos",
        regex: "^u$"
      },
      posseDeMesa: {
        tipo: "Outros Produtos",
        regex: "^p$"
      },
      placaDeHomenagem: {
        tipo: "Outros Produtos",
        regex: "^ph$"
      },
      canudos: {
        tipo: "Outros Produtos",
        regex: "^q$"
      },
      contagemRegressiva: {
        tipo: "Outros Produtos",
        regex: "^cr$"
      },
      banner: {
        tipo: "Outros Produtos",
        regex: "^bn$"
      },
      poster: {
        tipo: "Outros Produtos",
        regex: "^ps$"
      },
      personalizadas: {
        tipo: "Personalizadas",
        regex: "^pp$"
      }
    },
      tipo = arquivo.includes("pdf") ? arquivo.substring(arquivo.indexOf(".") + 1) : arquivo.substring(3, arquivo.indexOf(".")),
      publicacoes = this.state.publicacoes;
    for (var key in tipos) {
      if (new RegExp(tipos[key].regex).test(tipo)) {
        if (!publicacoes[tipos[key].tipo]) {
          publicacoes[tipos[key].tipo] = {nova:[],antiga:[]};
        }
        publicacoes[tipos[key].tipo].nova[Number(file.name.substring(0,3) - 1)] = file;
        if (!publicacoes[tipos[key].tipo].qtdNovas) {
          publicacoes[tipos[key].tipo].qtdNovas = 0;
        }
        !publicacoes[tipos[key].tipo].qtdNovas++;
        this.setState({publicacoes});
        return tipos[key].tipo;
      }
    }
    return null;
  }

  mudarTipo(event){
    this.setState({tipo: event.target.value});
  }

  imgViewProx(tipo){
    let indexImageView = this.state.indexImageView;
    if (this.state.publicacoes[tipo].nova.length > 8) {
      this.state.publicacoes[tipo].nova.length-1 === indexImageView[tipo] + 7 ? indexImageView[tipo] : indexImageView[tipo]++;
    } else {
      this.state.publicacoes[tipo].nova.length-1 === indexImageView[tipo] ? indexImageView[tipo] : indexImageView[tipo]++;
    }
    this.setState({indexImageView});
  }

  imgViewAnt(tipo){
    let indexImageView = this.state.indexImageView;
    indexImageView[tipo] === 0 ? indexImageView[tipo] = 0  : indexImageView[tipo]--;
    this.setState({indexImageView});
  }

  onKeyDown = (event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      this.getUltimasPub();
    }
  }

  resetar(){
    this.setState({
      uploading: false,
      fileList: [],
      contrato: 0,
      publicacoes: {},
      indexImageView:{
        'Paginação': 0,
        'Capa Dura': 0,
        'Embalagem': 0,
        'Encarte': 0,
        'Convite Simples': 0,
        'Senha de Entrada': 0,
        'Missal': 0,
        'Outros Produtos': 0,
        'Personalizadas': 0
      },
      contratoConfirmado: false,
      carregando: false,
      countFiles: 0,
      keyPublicacoes: [],
      respostasUpload: [],
      showModalCodigos: false,
      showModalUpload: false,
      percentItems: [],
    });
  }

  getUltimasPub(){
    this.setState({carregando:true});
    axios.get(`${REQUEST_URL}/contratos/findOne?filter={"where":{"numero":"${this.state.contrato}","status":{"neq":"deletado"}}}`).then(async (response) => {
      for(let i = 0;i< Object.keys(this.state.indexImageView).length;i++){
        let tipo = Object.keys(this.state.indexImageView)[i];
        await this.buscarUltimaPub(response.data.id,tipo);
      }
      this.setState({contratoConfirmado: true, carregando: false, idContrato: response.data.id});
    }).catch(error => {
      this.setState({carregando:false})
      toast.error('Não existe nenhum contrato com o numero informado',{position: "top-center",autoClose: 5000,draggable: true});
    });

  }

  buscarUltimaPub(contrato,tipo){
    axios.get(`${REQUEST_URL}/publicacoes?filter={"where":{"contrato":"${contrato}","tipo":"${tipo}"},"include":["paginas"],"order": "dataPublicacao DESC"}`).then((response) => {
      let pubs = response.data;
      let todasPaginas = {};
      pubs.forEach(publicacao => {
        publicacao.paginas.forEach(pagina => {
          if(!todasPaginas[pagina.nome]){
            todasPaginas[pagina.nome] = [];
          }
          todasPaginas[pagina.nome].push(pagina);
        })
      });
      let paginas = [];
      Object.values(todasPaginas).forEach(paginasArray => {
        paginas.push(paginasArray[0]);
      });
      let publicacao = response.data[0];
      let imagens = [];
      paginas.forEach((pagina) => {
        let img = {
          name:pagina.nome,
          tipo:pagina.tipo,
          url:FTP_URL+ pagina.publicacao +"/"+ pagina.nome,
          aprovada:pagina.aprovada
        }
        imagens.push(img);
      });
      let publicacoes = this.state.publicacoes;
      if(!publicacoes[tipo])publicacoes[tipo] = {"nova":[],antiga:[]};
      publicacoes[tipo].antiga = imagens.sort(function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
      publicacoes[tipo].dataPubAntiga = new Date(publicacao.dataPublicacao).toLocaleString();
      publicacoes[tipo].antiga.map((img)=>{
        publicacoes[tipo].nova.push({nome:"Aguardando",url:null});
      })
      this.setState({publicacoes});
    }).catch((error)=>{

    })
  }

  removerImagem(img, tipo){
    let publicacoes = this.state.publicacoes;
    let i;
    for(i=0;i<publicacoes[tipo].nova.length;i++){
      if(publicacoes[tipo].nova[i].name===img.name)break;
    }
    publicacoes[tipo].nova[i] = {nome: "Aguardando", url: null};
    this.setState({publicacoes});
  }

  render(){
    return(
      <div className="box panel-default" style={{padding:20}}>
        <div>
          <div className="form-group">
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <label htmlFor="numConvite">Contrato</label>
              <div style={{cursor: "pointer", color: "rgb(24, 144, 255)", textDecoration: "underline"}} onClick={() => this.setState({showModalCodigos: true})}>Ver lista de códigos</div>
            </div>
            <div className="input-group">
              <input id="inputContrato" autoFocus onKeyDown={this.onKeyDown} style={{borderRight:0}} type="number" className="form-control" disabled={this.state.contratoConfirmado} name="contrato" value={this.state.contrato} onChange={(event) => this.setState({contrato: event.target.value})} min="0" />
              <span className="input-group-btn">
                <button className="btn btn-danger" disabled={!this.state.contratoConfirmado} style={{borderRadius:0}} onClick={this.resetar.bind(this)}><i className="fa fa-times"/></button>
              </span>
              <span className="input-group-btn">
                <button className="btn btn-primary" type="submit" disabled={this.state.contratoConfirmado} onClick={this.getUltimasPub.bind(this)}>
                  {
                    this.state.contratoConfirmado ?
                      this.state.carregando ?
                        <div><i className="fa fa-spinner fa-spin"/></div>
                      : <div><i className="fa fa-check"></i></div>
                    : <div> Confirmar </div>
                  }
                </button>
              </span>
            </div>
          </div>
          {
            this.state.contratoConfirmado && !this.state.carregando ?
              <Upload.Dragger
                className="upload-list-inline"
                multiple={true}
                name="imagens"
                listType="text"
                onRemove={(file) => {
                  this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                      fileList: newFileList,
                    };
                  });
                }}
                beforeUpload={this.beforeUpload.bind(this)}
                fileList={this.state.fileList}
              >
                <p className="ant-upload-drag-icon"><InboxOutlined /></p>
                <p className="ant-upload-text">Clique ou arraste o arquivo nesta área para fazer o upload</p>
              </Upload.Dragger>
            : null
          }
          {
            this.state.contratoConfirmado && !this.state.carregando ?
              <div style={{marginTop: 20}}>
                {
                  Object.keys(this.state.publicacoes).map((tipo,i)=>{
                    if(this.state.publicacoes[tipo].antiga.length>0 || this.state.publicacoes[tipo].nova.length>0){
                      return (
                        <div key={i} style={publicacaoStyle}>
                          <h4>{tipo} ({this.state.publicacoes[tipo].antiga.length} Paginas) - Publicado dia {this.state.publicacoes[tipo].dataPubAntiga}</h4>
                          <div style={fileListStyle}>
                            <i style={buttonLeftStyle} onClick={this.imgViewAnt.bind(this,tipo)} className="fa fa-angle-left"></i>
                            <div name="conteudo" style={conteudoStyle}>
                              {
                                this.state.publicacoes[tipo].antiga.slice(this.state.indexImageView[tipo], this.state.indexImageView[tipo]+8).map((img,i)=>(
                                  <div key={i} style={imgBoxStyle}>
                                    {
                                      img.aprovada ?
                                        <div style={{ position: "absolute ", left: `0`, top: `0`, height: "100%", width: "100%"}}>
                                          <i className="fa fa-check" style={{textShadow: "2px 2px 4px #000000",color: "#00a65a", fontSize: 36, position: "absolute", left: "calc(50% - 18px)", top: "calc(50% - 18px)"}}></i>
                                        </div>
                                      : null
                                    }
                                    <img src={img.url} style={imgStyle}/>
                                    <p style={{textAlign: "center", color: "white"}}>{img.tipo + " " + Number(img.name.substring(0,3))}</p>
                                  </div>
                                ))
                              }
                            </div>
                            <i style={buttonRightStyle} onClick={this.imgViewProx.bind(this,tipo)} className="fa fa-angle-right"></i>
                          </div>
                          <h4>{tipo} ({this.state.publicacoes[tipo].qtdNovas ? this.state.publicacoes[tipo].qtdNovas : 0} Paginas) - Nova Publicação</h4>
                          <div style={fileListStyle}>
                            <i style={buttonLeftStyle} onClick={this.imgViewAnt.bind(this,tipo)} className="fa fa-angle-left"></i>
                            <div name="conteudo" style={conteudoStyle}>
                              {
                                this.state.publicacoes[tipo].nova.slice(this.state.indexImageView[tipo], this.state.indexImageView[tipo]+8).map((img,i) => (
                                  <div key={i} style={imgBoxStyle}>
                                    {
                                      img.url ?
                                        <i style={{position:"absolute",color:"#fff"}} onClick={() => this.removerImagem(img,tipo)} className="fa fa-times"/>
                                      : null
                                    }
                                    <img src={img.url} style={imgStyle}/>
                                    <p style={{textAlign:"center",color:"white"}}>{img.name}</p>
                                  </div>
                                ))
                              }
                            </div>
                            <i style={buttonRightStyle} onClick={this.imgViewProx.bind(this,tipo)} className="fa fa-angle-right"></i>
                          </div>
                        </div>
                      )
                    }  
                  })
                }
              </div>
            : null
          }
          <button className="upload-demo-start pull-right btn btn-success btn-lg" style={{position: "fixed", bottom: 15, right: 15}} onClick={this.abrirModalUpload} disabled={this.state.fileList.length === 0 || this.state.uploading || this.state.carregandoImagens}>
            {
              this.state.uploading ? 
                <span><i className="fa fa-spinner fa-spin"></i> Publicando </span>
              : this.state.carregandoImagens ?
                <span><i className="fa fa-spinner fa-spin"></i> Carregando imagens </span>
              : "Publicar páginas"
            }
          </button>
        </div>
        <Modal show={this.state.showModalCodigos} onHide={() => this.setState({showModalCodigos: false})} dialogClassName="modal-50w">
          <Modal.Header closeButton><Modal.Title>Códigos de Upload</Modal.Title></Modal.Header>
          <Modal.Body>
            <div style={{height: 500, overflowX: "auto"}}>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">PAGINAÇÃO</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>l</strong></td>
                      <td>Convite luxo</td>
                    </tr>
                    <tr>
                      <td><strong>j</strong></td>
                      <td>Página personalizada</td>
                    </tr>
                    <tr>
                      <td><strong>b</strong></td>
                      <td>Capa do bloco</td>
                    </tr>
                    <tr>
                      <td><strong>v</strong></td>
                      <td>Vegetal</td>
                    </tr>
                    <tr>
                      <td><strong>f</strong></td>
                      <td>Display flex personalizado</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">CAPA DURA</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>d</strong></td>
                      <td>Capa dura</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">EMBALAGENS</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>x</strong></td>
                      <td>Caixa</td>
                    </tr>
                    <tr>
                      <td><strong>ep</strong></td>
                      <td>Envelope</td>
                    </tr>
                    <tr>
                      <td><strong>i</strong></td>
                      <td>Invócucro</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">ENCARTE</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>e</strong></td>
                      <td>Encarte</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">CONVITE SIMPLES</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>s</strong></td>
                      <td>Convite simples</td>
                    </tr>
                  </tbody>
                </table>
              </div>      
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">SENHA DE ENTRADA</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>h</strong></td>
                      <td>Senha de entrada</td>
                    </tr>
                  </tbody>
                </table>
              </div>           
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">MISSAL</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>ms</strong></td>
                      <td>Missal</td>
                    </tr>
                  </tbody>
                </table>
              </div>         
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">OUTROS PRODUTOS</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>o</strong></td>
                      <td>Codex</td>
                    </tr>
                    <tr>
                      <td><strong>cc</strong></td>
                      <td>Capa do codex</td>
                    </tr>
                    <tr>
                      <td><strong>u</strong></td>
                      <td>Stand up</td>
                    </tr>
                    <tr>
                      <td><strong>p</strong></td>
                      <td>Posse de mesa</td>
                    </tr>
                    <tr>
                      <td><strong>ph</strong></td>
                      <td>Placa de homenagem</td>
                    </tr>
                    <tr>
                      <td><strong>q</strong></td>
                      <td>Canudos</td>
                    </tr>
                    <tr>
                      <td><strong>cr</strong></td>
                      <td>Contagem regressiva</td>
                    </tr>
                    <tr>
                      <td><strong>bn</strong></td>
                      <td>Banner</td>
                    </tr>
                    <tr>
                      <td><strong>ps</strong></td>
                      <td>Poster</td>
                    </tr>
                  </tbody>
                </table>
              </div>     
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr><th colSpan="2">PERSONALIZADAS</th></tr>
                    <tr>
                      <th>Código</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>pp</strong></td>
                      <td>Personalizadas</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.showModalUpload} dialogClassName="modal-50w">
          <Modal.Body>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <h4>Aguarde enquanto o sistema está cadastrando as publicações!</h4>
              <i className="fa fa-times fa-lg" style={{cursor: "pointer"}} onClick={() => this.setState({showModalUpload: false})}></i>
            </div>
            <div style={{fontSize: 18}}>
              {
                this.state.keyPublicacoes.map((key, i) => (
                  <div key={i} style={{display: "flex", alignItems: "center"}}> 
                    {
                      this.state.respostasUpload[i] === true ? 
                        <i style={{color: "#5cb85c"}} className="fa fa-check-circle"></i>
                      : this.state.respostasUpload[i] === false ?
                        <i style={{color: "#d9534f"}} className="fa fa-times-circle"></i>
                      : <i className="fa fa-spinner fa-spin"></i>
                    } 
                    <span style={{marginLeft: 10}}>{this.state.percentItems[i]}%</span>
                    <span style={{marginLeft: 5}}>{key}</span>
                  </div>
                ))
              }
            </div>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}

const publicacaoStyle = {backgroundColor: "#E5E5E5", padding: 5, marginTop: 10, border: "2px solid #afadad"},
  fileListStyle = {backgroundColor: "#222d32", width: "100%", height: 140, marginTop: 0, borderLeft: "5px solid black", borderRight: "5px solid black", paddingLeft: 30, paddingRight: 30, position: "relative"},
  buttonLeftStyle = {fontSize: 70, color: "#d2d6de", position: "absolute", top: "30px", left: 0, cursor: "pointer"},
  buttonRightStyle = {fontSize: 70, color: "#d2d6de", position: "absolute", top: "30px", right: 0, cursor: "pointer"},
  conteudoStyle = {overflow: "hidden", display: "flex", flexDirection: "row", flexWrap: "nowrap", height: "100%", padding: 5},
  imgBoxStyle = {textAlign: "center", height: "100%", margin: "0px 5px 0px 5px", position: "relative", minWidth: 150, flex: 1},
  imgStyle = {height: 110, display: "block", marginLeft: "auto", marginRight: "auto"};


// WEBPACK FOOTER //
// ./src/views/CadastrarPublicacao.js